import React from 'react';
import Head from 'next/head';
export type PreloadImageProps = {
  src: string;
};
export const PreloadImage = ({
  src
}: PreloadImageProps) => <Head data-sentry-element="Head" data-sentry-component="PreloadImage" data-sentry-source-file="index.tsx">
    <link rel="preload" href={src} as="image" {...{
    fetchpriority: 'high'
  }} />
  </Head>;